exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Gallery-9a41ffbf{position:fixed;top:0;right:0;bottom:0;left:0;background:#222;color:#7d7d7d;z-index:9999;display:flex;flex-direction:column;justify-content:space-between}.exit-ed9afc1e{position:absolute;z-index:99;top:10px;right:10px;cursor:pointer;color:#ccc}.exit-ed9afc1e:hover{color:white}body.gallery-open{overflow:hidden}\n", ""]);

// Exports
exports.locals = {
	"Gallery": "Gallery-9a41ffbf",
	"exit": "exit-ed9afc1e"
};